<template>
    <div class="page_index" :style="rankStyle">
        <div class="page_main">
            <div class="page_title" :class="customClass" :style="titleStyle">{{title}}</div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import {
        fontVh
    } from "@/assets/js/common";
    export default {
        name: 'border',
        props: {
            tenderImg: {
                type: String,
                default: ''
            },
            width: {
                type: [Number, String],
                default: 643
            },
            height: {
                type: [Number, String],
                default: 297
            },
            left: {
                type: [Number, String],
                default: 60
            },
            fontSize: {
                type: [Number, String],
                default: 30
            },
            title: {
                type: String,
                default: '标题'
            },
            bottom: {
                type: [Number, String],
                default: 0
            },
            customClass: {
                type: String,
                default: ''
            },
            color:{
                type: String,
                default: ''
            }
        },
        data() {
            return {
                thisYear: new Date().getFullYear()
            }
        },
        components: {

        },
        created() {},
        computed: {
            rankStyle() {
                const {
                    width,
                    height,
                    tenderImg,
                    bottom
                } = this
                return `width:${fontVh(width)};height:${fontVh(height)};background: url(${tenderImg})top center no-repeat;background-size: 100% 100%;margin-bottom:${fontVh(bottom)};`
            },
            titleStyle() {
                const {
                    left,
                    fontSize
                } = this
                let result =`left:${fontVh(left)};font-size:${fontVh(fontSize)};`
                if(this.color){
                    result+=`color:${this.color};`
                }
                return result
            }
        },
        watch: {},
        methods: {
            onTimeClick(idx) {
                this.$emit('onTimeClick', idx)
            }
        }
    }
</script>

<style lang='scss' scoped>
    .page_index {

        // margin-bottom: 14px;
        .page_main {
            position: relative;

            .page_top {
                position: absolute;
                top: vh(33);
                right: vh(20);
            }

            .page_title {
                height: vh(60);
                position: absolute;
                top: vh(13);
                color: #FFFFFF;
                font-size: vh(30);
                font-weight: bold;
            }
        }
    }
</style>